import { useEffect, useState } from "react";
import "./_AdminContent.scss";
import _AdminNavBar from "./_AdminNavBar/_AdminNavBar";
import _Dashboard from "./Contents/_Dashboard/_Dashboard";
import _Products from "./Contents/_Products/_Products";
import _Orders from "./Contents/_Orders/_Orders";

import { getRedirect } from "./utils/_redirect";
import _Landing from "./Contents/_Landing/_Landing";
import _User from "./Contents/_User/_User";
function _AdminContent() {
  const navstructure = ["DASHBOARD", "USERS", "PRODUCT INFO", "ORDERS"];
  const content = [_Dashboard, _User, _Products, _Orders];
  const redirectState = getRedirect();
  const { nav, side } = redirectState;
  const [activeNav, setActiveNav] = useState(nav || 0); // Usually start from 0

  const ActiveComponent = content[activeNav]; // get the component

  useEffect(() => {
    if (nav > navstructure.length) {
      setActiveNav(navstructure.length);
    }
  }, [activeNav]);
  return (
    <>
      <_AdminNavBar
        navStructure={navstructure}
        activeNav={activeNav}
        setActiveNav={setActiveNav}
      />
      <ActiveComponent side={side} /> {/* Render as JSX */}
    </>
  );
}

export default _AdminContent;
